import React, { Component } from "react";
import axios from 'axios';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import moment from 'moment';
import { ROOT_URL, ROOT_API_URL, isSDR, isCRW, isSC, isBRO } from '../../actions/root_url';
import GenericSelection from '../Common/GenericSelection';


const priceLevelOptions = [
  {label: "1", value: "1"},
  {label: "2", value: "2"},
  {label: "3", value: "3"},
  {label: "4", value: "4"},
  {label: "5", value: "5"},
];

const dataValid = (data) => {
    // if (!data.Name || !data.CustomerNum || !data.Mailing.Telephone || !data.Mailing.Street || !data.Mailing.City || !data.Mailing.State || !data.Mailing.Zip) {
    if (!data.Name) {
      return;
    }
  return true;
}

const fetchCustomerDetails = (receivingCustomer, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}/v1/customer/${receivingCustomer}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success(res);
    }, err => {

    })
}

class CustomerCreateModal extends Component {
  constructor() {
    super();
    this.state = {
      buttonDisabled: false,
      submitData: {},
      mailingTemp: {
        City: "",
        State: "",
        Street: "",
        Telephone: "",
        Zip: "",
      },
    };
  }

  componentDidMount() {
    let submitData = {
      BusinessType: "",
      Company_id: this.props.Company_id.value,
      CreateDate: moment().toISOString(),
      CreditStatus: "Good",
      CustomerNum: "",
      IsActive: "true",
      IsInternal: "false",
      IsPrtGeneralInfor: "false",
      IsPrtReminder: "false",
      IsShowPrice: "true",
      IsStripe: "false",
      IsWholesale: "false",
      Mailing: {},
      Billing: {},
      Name: "",
      OrderType: "",
      PriceLevel: "5",
      StartDate: moment().toISOString(),
      Sub_Customer_id: "",
      Reseller: "",
      PriceLevel: "5",
      Email: "",
    }
    this.setState({submitData});

    if (this.props.enteringPhone && (isSDR || isCRW || isSC)) {
      this.state.mailingTemp.Telephone = this.props.enteringPhone;
    }
  }

  handleInputFieldChange = ({ name, value }) => {
    let {mailingTemp, submitData} = this.state;
    if (name === "Name" || name === "CustomerNum" || name === "Reseller") {
      submitData[name] = value;
      this.setState({ submitData });
    } else {
      mailingTemp[name] = value;
      this.setState({ mailingTemp });
    }
  }

  handleDropdownChange = ( target ) => {
    let {mailingTemp, submitData} = this.state;
    submitData['PriceLevel'] = target.value;
    this.setState({ submitData });
  }

  // handleFetchCustomerDetailsSuccess = ({ data }) => {
  //   this.setState({
  //     IsDefault: "true",
  //     AddressName: "",
  //     Telephone: "",
  //     Street: "",
  //     City: "",
  //     State: "",
  //     Zip: "",
  //     Email: "",
  //     Cellphone: "",
  //     customerDetails: data,
  //   })
  // }

  handleSubmit = () => {
    let {mailingTemp, submitData} = this.state;

    mailingTemp.AddressName = submitData.Name;
    submitData.Mailing = mailingTemp;
    submitData.Billing = mailingTemp;
    // this.setState({submitData});
    // submitData.Company_id = this.props.Company_id;

    if (!dataValid(submitData)) {
      alert('Please fill out all fields');
      return;
    }

    this.setState({
      buttonDisabled: true,
    });
    axios({
      method: 'POST',
      url: `${ROOT_URL}v1/customer/`,
      data: submitData,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(res => {
        alert("Customer Added!");
        this.props.reFetchSalesCustomers(submitData);
        this.setState({
          buttonDisabled: false,
        });
        this.props.closeCustomerEditModal();
      }, err => {
        const data = err.data;
        alert(JSON.stringify(data));
      })
  };

  render() {
    const { mailingTemp, submitData } = this.state;
    return (
      <div>
        <Row>
        <Col sm={6}>
            <label>
              <Translate value="name" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="customer_number" />:
            </label>
          </Col>
        </Row>
        <Row>
        <Col sm={6}>
            <Input
              type="text"
              name="Name"
              value={submitData.Name}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="CustomerNum"
              value={submitData.CustomerNum}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
     
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="street" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="city" />:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="Street"
              value={mailingTemp.Street}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="City"
              value={mailingTemp.City}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="state" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="zip" />:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="State"
              value={mailingTemp.State}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="Zip"
              value={mailingTemp.Zip}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>


        <Row>
          <Col sm={6}>
            <label>
              <Translate value="telephone" />:
            </label>
          </Col>
          {
            (isSDR || isCRW || isSC) && 
            <Col sm={6}>
              <label>
                <Translate value="reseller" />:
              </label>
            </Col>
          }
                    {
            (isBRO) && 
            <Col sm={6}>
              <label>
                <Translate value="email" />:
              </label>
            </Col>
          }
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="Telephone"
              value={mailingTemp.Telephone}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          {
            (isSDR || isCRW || isSC) && 
            <Col sm={6}>
              <Input
                type="text"
                name="Reseller"
                value={submitData.Reseller}
                onChange={(e) => this.handleInputFieldChange(e.target)}
              />
          </Col>
          }
                    {
            (isBRO) && 
            <Col sm={6}>
              <Input
                type="text"
                name="Email"
                value={mailingTemp.Email}
                onChange={(e) => this.handleInputFieldChange(e.target)}
              />
          </Col>
          }
        </Row>

{isBRO &&
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="price_level" />:
            </label>
          </Col>
        </Row>
  }
  {isBRO &&

        <Row>
          <Col sm={6}>
            {/* <Input
              type="text"
              name="PriceLevel"
              value={submitData.PriceLevel}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            /> */}
                            <div className="pricebro">
<GenericSelection
                    options={priceLevelOptions}
                    value={submitData.PriceLevel}
                    setSelected={(e) => {this.handleDropdownChange(e)}}
                  />
</div>
          </Col>
        </Row>
  }

        <Row className="centerStyle" style={{ marginTop: "0px" }}>
          <Button
            bsStyle="success"
            disabled={this.state.buttonDisabled}
            onClick={(e) => {
              this.handleSubmit();
            }}
          // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
          >
            <Translate value="submit" />
          </Button>
        </Row>
      </div>
    );
  }
}

export default CustomerCreateModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/CustomerCreateModal.jsx